import * as React from 'react';

import {ClockWithTimezone, regionTimeZones, timeZonesMap} from '../../../components/Clock';
import { DropDownMenu, MenuItem } from 'material-ui';
import { DurationUnit, Experiment, ExperimentMeta, ExperimentVariant, GlanceDraft, GlanceType, Partner, PartnerMeta, Region, SegmentTargetingRule } from 'glance-datatypes';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import {blue300, red500} from 'material-ui/styles/colors';

import Chip from 'material-ui/Chip';
import ChipInput from 'material-ui-chip-input';
import DatePicker from 'material-ui/DatePicker';
import Divider from 'material-ui/Divider';
import Subheader from 'material-ui/Subheader';
import TextField from 'material-ui/TextField';
import TimePicker from 'material-ui/TimePicker';
import Toggle from 'material-ui/Toggle';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import Utils from '../../../Utils';
import PartingTimeSelection from './PartingTimeSelection';

const styles = {
    subheader: {
        lineHeight: '1em',
    } as React.CSSProperties,
    width100: {
        width: '100%',
        maxWidth: 'none',
    } as React.CSSProperties,
    chipWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
    } as React.CSSProperties,
    chip: {
        margin: 3,
    } as React.CSSProperties,
    durationWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
    } as React.CSSProperties,
    radioButton: {
        margin: 'auto 10px',
        width: 'auto',
    } as React.CSSProperties,
    dateTimeStyle : {
        display: 'inline-block',
        flexGrow: 100,
    } as React.CSSProperties,
    inputStyle : {
        color: '#505050',
        fontSize: '0.9em',
    } as React.CSSProperties,
    iframe : {
        height: '100vh',
        width: '100%',
        border: 'none',
    } as React.CSSProperties,
    ruleDialog : {
        maxWidth: 'none',
    } as React.CSSProperties,
    divider:{
        marginTop:'12px',
        marginBottom: '8px'
    }
};

export interface PartnerSource {
    text: string;
    value: Partner;
}

export interface ABMapping {
    partnerId: string;
    abTag: string;
}

export interface RegionPublishMeta {
    partnerSources: PartnerSource[];
    publishedTo?: Partner[];
    publishTo?: PartnerSource[];
    startTimeType?: StartTimeType;
    startDate?: Date;
    startTime?: Date;
    durationUnit?: DurationUnit;
    duration?: number;
    userLevelDurationEnabled?: boolean;
    userLevelDuration?: number;
    userLevelDurationUnit?: DurationUnit;
    publishToSelected?: string;
    abMappings?: ABMapping[];
    abSelectedMappings?: ABMapping[];
    abSelected?: ABMapping[];
    selectedExperiments?: ExperimentMeta[];
    selectedExperimentMetas?: ExperimentMeta[];
    selectedSegmentRulesList?: SegmentTargetingRule[][];
    partingSchedule?: any;
    isPartedGlance?: boolean;
}

export interface DefaultValues {
    startTimeType: StartTimeType;
    startDate: Date;
    startTime: Date;
    durationUnit: DurationUnit;
    duration: number;
}


export interface UserLevelDefaultValues {
    enabled: boolean;
    durationUnit: DurationUnit;
    duration: number;
}

interface Props {
    region: Region;
    experiments: Map<string, Experiment>;
    segmentRules: any[];
    regionPublishMeta: RegionPublishMeta;
    defaultValues: DefaultValues;
    userLevelDefaultValues: UserLevelDefaultValues;
    shortTitleCheck: Boolean;
    cheesySummaryCheck: Boolean;
    partnerMetas: PartnerMeta[];
    draft: GlanceDraft;
    isSettingsView: Boolean;
    onDurationUpdate: (unit: DurationUnit, value: number) => any;
    onUserLevelDurationUpdate: (enabled: boolean, unit?: DurationUnit, value?: number) => any;
    onPartingTimeUpdate:(enabled: boolean, schedule: any)=>any;
    onStartTimeUpdate: (type: StartTimeType, startDate: Date, startTime: Date) => any;
    partnerAdded: (chip: PartnerSource) => any;
    partnerRemoved: (chip: Partner, index: number) => any;
    abPartitionAdded?: (chip: ABMapping) => any;
    abPartitionRemoved?: (chip: ABMapping) => any;
    experimentAdded: (experimentId: String) => any;
    variantSelected: (variantId: String, experimentId: String) => any;
    variantRemoved: (chip: ExperimentVariant, experimentId: String) => any;
    onSegmentRuleSelected: (rule: SegmentTargetingRule, isAdd: boolean, index: number) => void;
    addSegmentRuleFromGambit?: (rule: SegmentTargetingRule) => void;
    onTargetingRuleDeleted?: (index: number) => void;
    isDspCampaign: boolean;
}

export enum StartTimeType {
    NOW = 0,
    MANUAL = 1,
}

interface State {
    partnerIdPartnerMetaMap: Map<String, PartnerMeta>;
    durationType: DurationUnit;
    startTimeType: StartTimeType;
    openRule: boolean;
    partingSchedule: { [k: string]: Array<{ startTime: number, endTime: number }>; };
    targetingRulesLength: number;
    currentTargetingRule: number;
}

const DSPPartners = ['Xiaomi', 'Realme', 'Samsung DLSS', 'Samsung Android'];
export class GlanceRegionPublish extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        const partnerIdPartnerMetaMap: Map<String, PartnerMeta> = new Map<String, PartnerMeta>();
        this.props.partnerMetas.forEach((partner) => {
            partnerIdPartnerMetaMap.set(partner.partnerId, partner);
        });
        this.state = {
            durationType : DurationUnit.DAYS,
            startTimeType: StartTimeType.NOW,
            partnerIdPartnerMetaMap: partnerIdPartnerMetaMap,
            openRule: false,
            partingSchedule: {
                MONDAY: [{startTime: 8, endTime: 10 }, {startTime: 16, endTime: 18 }],
                TUESDAY: [{startTime: 8, endTime: 10 }, {startTime: 16, endTime: 18 }],
                WEDNESDAY: [{startTime: 8, endTime: 10 }, {startTime: 16, endTime: 18 }],
                THURSDAY: [{startTime: 8, endTime: 10 }, {startTime: 16, endTime: 18 }],
                FRIDAY: [{startTime: 8, endTime: 10 }, {startTime: 16, endTime: 18 }],
                SATURDAY: [{startTime: 8, endTime: 11 }, {startTime: 16, endTime: 20 }],
                SUNDAY: [{startTime: 8, endTime: 11 }, {startTime: 16, endTime: 20 }],
            },
            targetingRulesLength: this.props.regionPublishMeta.selectedSegmentRulesList &&
                this.props.regionPublishMeta.selectedSegmentRulesList.length > 0
                ? this.props.regionPublishMeta.selectedSegmentRulesList.length
                : 2,
            currentTargetingRule: 0
        };
        this.canPartnerPublish = this.canPartnerPublish.bind(this);
        this.getVariantName = this.getVariantName.bind(this);
        this.isVariantInSelectedExperiments = this.isVariantInSelectedExperiments.bind(this);
    }

    canPartnerPublish(value: Partner) {
        let response: boolean = false;
        if (!this.props.draft && this.props.isSettingsView) return true;
        if (this.props.draft.type != GlanceType.SPONSORED) {
            response = true;
        } else {
            const partnerMeta: PartnerMeta = this.state.partnerIdPartnerMetaMap.get(value.partnerId);
            if (!partnerMeta) {
                response = false;
            } else {
                response = partnerMeta.isSponsoredEnabled ? partnerMeta.isSponsoredEnabled : false;
            }
        }
        return response;
    }

    getExperiment(experimentId: string) {
        return this.props.experiments.get(experimentId);
    }

    handleCreateRule = (index: number) => {
        this.setState({
            ...this.state,
            openRule: true,
            currentTargetingRule: index
        });
    };

    closeCreateRule = () => {
        this.setState({
            ...this.state,
            openRule: false,
        });
    };

    getVariantName(experimentId: string, variantId: string) {
        const experiment = this.props.experiments.get(experimentId);
        if (experiment) {
            if (experiment.control.id == variantId) {
                return experiment.control.name;
            }
            experiment.variants.forEach((variant) => {
                if (variant.id == variantId) {
                    return variant.name;
                }
            });
        }

        return 'INVALID VARIANT';
    }

    isVariantInSelectedExperiments(variantId: String) {
        const regionPublishMeta = this.props.regionPublishMeta;
        if (regionPublishMeta.selectedExperimentMetas && regionPublishMeta.selectedExperimentMetas.length > 0) {
            const flag = regionPublishMeta.selectedExperimentMetas.map((variant) => {
                if (variant.variantId == variantId) {
                    return true;
                }
            });
            return flag.includes(true);
        }
        return false;
    }

    handleSegmentRuleChange = (value, isAdd, index: number) => {
        this.props.onSegmentRuleSelected(value, isAdd, index);
    }

    handleAddNewRule = () => {
        const currentLength = this.state.targetingRulesLength;
        if (currentLength < 5) {
            this.setState({
                ...this.state,
                targetingRulesLength: currentLength + 1
            })
        }
    }

    handleDeleteRule = (index: number) => {
        this.props.onTargetingRuleDeleted(index);
        const currentLength = this.state.targetingRulesLength;
        this.setState({
            ...this.state,
            targetingRulesLength: currentLength - 1
        });
    }

    receiveMessage = (event: any) => {
        if (event.data.value) {
            this.props.addSegmentRuleFromGambit(event.data.value);
            this.handleSegmentRuleChange(event.data.value, true, this.state.currentTargetingRule);
            this.setState({
                ...this.state,
                openRule: false,
            })
        }
    };

    componentDidMount() {
        window.addEventListener('message', this.receiveMessage, false);
        //for now..
        if(this.props.regionPublishMeta.partingSchedule)this.setState({...this.state,partingSchedule:this.props.regionPublishMeta.partingSchedule})
    }

    componentWillUnmount(){
        window.removeEventListener('message', () => {
            console.log('Listener destroyed');
        });
    }


    handlePartingDataChange = (day, index, startTime, endTime) => {
        const partingSchedule = this.state.partingSchedule;
        partingSchedule[day][index] = {startTime, endTime}
        this.setState({...this.state, partingSchedule })
        this.props.onPartingTimeUpdate(true, partingSchedule);
    }

    handleRemoveSlot = (day, index) => {
        const partingSchedule = this.state.partingSchedule;
        if (index > -1) {
            partingSchedule[day].splice(index, 1);
        }
        this.setState({...this.state, partingSchedule })
        this.props.onPartingTimeUpdate(true, partingSchedule);
    }

    render() {
        const regionPublishMeta: RegionPublishMeta = this.props.regionPublishMeta;
        const { selectedSegmentRulesList: selectedSegmentRulesNew = [] } = this.props.regionPublishMeta;
        const defaultValues: DefaultValues = this.props.defaultValues;
        const userLevelDefaultValues: UserLevelDefaultValues = this.props.userLevelDefaultValues;

        const durationUnit : DurationUnit = regionPublishMeta.durationUnit ? regionPublishMeta.durationUnit : defaultValues.durationUnit;
        const duration : number = regionPublishMeta.duration ? regionPublishMeta.duration : defaultValues.duration;
        const startTimeType : StartTimeType = regionPublishMeta.startTimeType ? regionPublishMeta.startTimeType : defaultValues.startTimeType;
        const startDate: Date = regionPublishMeta.startDate ? regionPublishMeta.startDate : defaultValues.startDate;
        const startTime: Date = regionPublishMeta.startTime ? regionPublishMeta.startTime : defaultValues.startTime;

        const userLevelDurationEnabled : boolean = userLevelDefaultValues.enabled;
        const isPartedGlance: boolean = regionPublishMeta.isPartedGlance;
        const partingSchedule = regionPublishMeta.partingSchedule || this.state.partingSchedule;
        const userLevelDurationUnit : DurationUnit = regionPublishMeta.userLevelDurationUnit ? regionPublishMeta.userLevelDurationUnit : userLevelDefaultValues.durationUnit;
        const userLevelDuration: number = regionPublishMeta.userLevelDuration ? regionPublishMeta.userLevelDuration : userLevelDefaultValues.duration;

        const filteredABMappings = regionPublishMeta.abMappings.filter(abMapping => abMapping.partnerId == regionPublishMeta.publishToSelected);

        const experimentOptions = [];
        let selectedExperimentMeta = null;
        let selectedExperiment = null;
        if (this.props.regionPublishMeta.selectedExperiments) {
            if (this.props.regionPublishMeta.selectedExperiments.length == 0) {
                selectedExperimentMeta = {
                    id: null,
                    variantId: null,
                };
                selectedExperiment = null;
            } else {
                selectedExperimentMeta = this.props.regionPublishMeta.selectedExperiments[0];
                selectedExperiment = this.getExperiment(selectedExperimentMeta.id);
            }
        }
        if (this.props.experiments) {
            this.props.experiments.forEach((experiment, id) => {
                experimentOptions.push(<MenuItem value={id} primaryText={experiment.name} key={'experiment_' + id}></MenuItem>);
            });
        }
        return (
            <div style={{marginTop: '1em'}}>
                {
                    this.props.isSettingsView ? '' :
                        <div style={styles.chipWrapper}>
                            <div style={{margin: 'auto 0px'}}>Published Partners: </div>
                            {
                                regionPublishMeta.publishedTo && regionPublishMeta.publishedTo.length > 0 ?
                                    regionPublishMeta.publishedTo.map((partner) => {
                                        return (
                                            <Chip style={styles.chip} key={'selected' + partner.partnerId + this.props.region} backgroundColor={blue300}>
                                                {partner.name}
                                            </Chip>
                                        );
                                    }) :  <Chip style={styles.chip}> None </Chip>
                            }
                        </div>
                }

                <br/>
                {
                    <div style={styles.chipWrapper}>
                        <div style={{margin: 'auto 0px'}}>Select Partners: </div>
                        {
                            regionPublishMeta.partnerSources &&  regionPublishMeta.partnerSources.length > 0?
                                regionPublishMeta.partnerSources
                                .filter((e) => !this.props.isDspCampaign || DSPPartners.indexOf(e.value.name) != -1)
                                .map((source) => {
                                    const isSelected = regionPublishMeta.publishTo ? regionPublishMeta.publishTo.indexOf(source) != -1 : false;
                                    return (
                                        this.canPartnerPublish(source.value) ?
                                            <Chip style={styles.chip} key={'inp' + source.value.partnerId + this.props.region}
                                                backgroundColor={isSelected ? blue300 : ''}
                                                onTouchTap={() => {
                                                    isSelected ? this.props.partnerRemoved(source.value, 0) :
                                                        this.props.partnerAdded(source);
                                                }}>
                                                {source.value.name}
                                            </Chip> : ''
                                    );
                                })
                                : <Chip style={styles.chip}> All partners done!</Chip>
                        }
                    </div>
                }
                <br/>
                {!this.props.isDspCampaign && <div>
                {
                    regionPublishMeta.publishTo != null && regionPublishMeta.publishTo.length > 0?
                        <div>
                            <div style={styles.chipWrapper}>
                                <div style={{margin: 'auto 0px'}}>Select Experiment: </div>
                                {
                                    this.props.experiments ?
                                        <DropDownMenu value={this.props.regionPublishMeta.selectedExperiments
                                            ? selectedExperimentMeta.id : null} onChange={(e, i, value) => { this.props.experimentAdded(value);} }>
                                            <MenuItem value={null} primaryText={'Click here select to an experiment'} key={'empty'}></MenuItem>
                                            {
                                                experimentOptions
                                            }

                                        </DropDownMenu>
                                        : ''
                                }

                            </div>
                            <div style={styles.chipWrapper}>
                                <div style={{ margin: 'auto 0px' }}>Select Targeting Rules: </div>
                                {
                                    new Array(this.state.targetingRulesLength).fill(0).map((value, index) => {
                                        return (
                                            <div style={{ width: '100%' }}>
                                                <ChipInput
                                                    key={`segmentRules${index}`}
                                                    hintText={'Select Targeting Rules'}
                                                    style={{ width: '40%', marginLeft: 20 }}
                                                    value={selectedSegmentRulesNew[index] && selectedSegmentRulesNew[index].length > 0 ? selectedSegmentRulesNew[index] : []}
                                                    dataSource={this.props.segmentRules}
                                                    dataSourceConfig={{ text: 'name', value: 'ruleId' }}
                                                    onRequestAdd={(chip) => this.handleSegmentRuleChange(chip, true, index)}
                                                    onRequestDelete={(chip) => this.handleSegmentRuleChange(chip, false, index)}
                                                    disabled={false}
                                                />
                                                <FlatButton style={{ position: 'absolute' }} label='Create Targeting Rule' primary={true} onClick={() => this.handleCreateRule(index)} />
                                                <FlatButton style={{ position: 'absolute', 'marginLeft': '20%' }} label='Delete Rule' primary={true} onClick={() => this.handleDeleteRule(index)} />
                                            </div>
                                        )
                                    })
                                }
                                <FlatButton disabled={this.state.targetingRulesLength === 5} label='Add New Rule (Max 5)' primary={true} onClick={this.handleAddNewRule} />
                                <label style={{ 'fontWeight': 'bold', 'padding-top': '8px' }}>Union within Rules and Intersection across rules</label>
                            </div>
                            <Dialog modal={false}
                                open={this.state.openRule}
                                onRequestClose={this.closeCreateRule}
                                autoScrollBodyContent={true}
                                contentStyle={styles.ruleDialog}
                            >
                                <iframe style={styles.iframe} src={`${Utils.getGambitUrl()}/segment-rule/create`}></iframe>
                            </Dialog>
                        </div>
                        : ''
                }

                {
                    regionPublishMeta.publishTo != null && regionPublishMeta.publishTo.length > 0 && regionPublishMeta.selectedExperiments != null && regionPublishMeta.selectedExperiments.length > 0 && selectedExperiment ?
                        <div>
                            <div style={styles.chipWrapper}>
                                <div style={{margin: 'auto 0px'}}>Select Experiment group: </div>
                                {
                                    this.props.regionPublishMeta.selectedExperiments &&  this.props.regionPublishMeta.selectedExperiments.length > 0 ?
                                        selectedExperiment.variants.map((variant) => {
                                            const isSelected = this.isVariantInSelectedExperiments(variant.id);
                                            return (
                                                <Chip style={styles.chip} key={'variant_' + selectedExperiment.id + '_' + variant.id}
                                                    backgroundColor={isSelected ? blue300 : ''}
                                                    onTouchTap={() => {
                                                        isSelected ? this.props.variantRemoved(variant, selectedExperiment.id) :
                                                            this.props.variantSelected(variant.id, selectedExperiment.id);
                                                    }}>
                                                    {variant.name}
                                                </Chip>
                                            );
                                        }) : ''
                                }
                                {
                                    <Chip style={styles.chip} key={'control_variant_' + selectedExperiment.id + '_' + selectedExperiment.control.id}
                                        backgroundColor={this.isVariantInSelectedExperiments(selectedExperiment.control.id) ? blue300 : ''}
                                        onTouchTap={() => {
                                            this.isVariantInSelectedExperiments(selectedExperiment.control.id) ? this.props.variantRemoved(selectedExperiment.control, selectedExperiment.id) :
                                                this.props.variantSelected(selectedExperiment.control.id, selectedExperiment.id);
                                        }}>
                                        {selectedExperiment.control.name}
                                    </Chip>

                                }
                            </div>
                        </div>
                        : ''
                }
                {
                    !this.props.shortTitleCheck ?
                        <div style={{display: 'flex', margin: '0px auto', color:red500}}> Short title is mandatory for this partner </div> : ''
                }
                {
                    !this.props.cheesySummaryCheck ?
                        <div style={{display: 'flex', margin: '0px auto', color:red500}}> Cheesy summary is mandatory for this partner </div> : ''
                }
                <br/>
                <Subheader style={styles.subheader}> Start Time </Subheader>
                <div style={styles.durationWrapper}>
                    <RadioButtonGroup style={{margin: 'auto', display: 'flex', marginRight: '2em'}} name='Start Time'
                        valueSelected={startTimeType}
                        onChange={(e, value) => {
                            this.props.onStartTimeUpdate(value == '0' ? StartTimeType.NOW : StartTimeType.MANUAL, startDate, startTime);
                        }}>
                        <RadioButton
                            value={StartTimeType.NOW}
                            label='Now'
                            style={styles.radioButton}
                        />

                        <RadioButton
                            value={StartTimeType.MANUAL}
                            label='Manual'
                            style={styles.radioButton}
                        />
                    </RadioButtonGroup>
                    <DatePicker key='start_date'  hintText='Start Date' value={startDate} autoOk={true}
                        onChange={(_, date) => {
                            this.props.onStartTimeUpdate(startTimeType, date, startTime);
                        }}
                        style={styles.dateTimeStyle} textFieldStyle={styles.width100} inputStyle={styles.inputStyle}
                        disabled={startTimeType == StartTimeType.NOW}/>
                    <TimePicker key='start_time'  hintText='Start Time' value={startTime} autoOk={true}
                        onChange={(_, date) => {
                            this.props.onStartTimeUpdate(startTimeType, startDate, date);
                        }}
                        style={styles.dateTimeStyle} textFieldStyle={styles.width100} inputStyle={styles.inputStyle} format='24hr'
                        disabled={startTimeType == StartTimeType.NOW}/>
                </div>

                <Subheader style={styles.subheader}> Duration </Subheader>
                <div style={styles.durationWrapper}>
                    <RadioButtonGroup style={{margin: 'auto', display: 'flex'}} name='Duration' valueSelected={durationUnit}
                        onChange={(e, value) => {
                            if(value == '0') {
                                this.props.onDurationUpdate(DurationUnit.HOURS, duration);
                            }else if(value == '1') {
                                this.props.onDurationUpdate(DurationUnit.DAYS, duration);
                            }else if(value == '2') {
                                this.props.onDurationUpdate(DurationUnit.MINUTES, duration);
                            }else if(value == '3') {
                                this.props.onDurationUpdate(DurationUnit.SECONDS, duration);
                            }
                        }}>
                        <RadioButton
                            value={DurationUnit.HOURS}
                            label='Hours'
                            style={styles.radioButton}
                        />

                        <RadioButton
                            value={DurationUnit.DAYS}
                            label='Days'
                            style={styles.radioButton}
                        />
                        <RadioButton
                            value={DurationUnit.MINUTES}
                            label='Minutes'
                            style={styles.radioButton}
                        />
                        <RadioButton
                            value={DurationUnit.SECONDS}
                            label='Seconds'
                            style={styles.radioButton}
                        />
                    </RadioButtonGroup>
                    <TextField
                        style={{flexGrow: 100, marginLeft: '2em'}}
                        hintText={durationUnit == DurationUnit.HOURS ? 'Hours': 'Days'}
                        type='number'
                        value={duration}
                        onChange={ (e, value) =>
                            this.props.onDurationUpdate(durationUnit, value ? parseInt(value) : null)
                        }
                    />
                </div>

                <Subheader style={{...styles.subheader, paddingTop: '1em'}}> Current Time </Subheader>
                <div style={styles.durationWrapper}>
                    {
                        regionTimeZones[this.props.region].map((timezone) => {
                            return (
                                <div style={{margin: '15px auto'}} key={timezone}>
                                    <ClockWithTimezone key={timezone} customStyle={{margin: 'auto'}} timezone={timeZonesMap.get(timezone)}/>
                                </div>
                            );
                        })
                    }

                </div>

                {
                    <div>
                        <Divider style={styles.divider} />
                        <Subheader style={styles.subheader}> User Level Duration </Subheader>

                        <Toggle
                            label={userLevelDurationEnabled ? 'User level expiry enabled' : 'User level expiry disabled'}
                            labelPosition='right'
                            defaultToggled={userLevelDurationEnabled}
                            onToggle={(e, checked) => this.props.onUserLevelDurationUpdate(checked, userLevelDurationUnit, userLevelDuration)}
                        />
                    </div>
                }
                {
                    <div style={styles.durationWrapper}>
                        <RadioButtonGroup style={{margin: 'auto', display: 'flex'}} name='UserLevelDuration' valueSelected={userLevelDurationUnit}
                            onChange={(e, value) => {
                                this.props.onUserLevelDurationUpdate(true, value == '0' ? DurationUnit.HOURS : DurationUnit.DAYS, userLevelDuration);
                            }}>

                            <RadioButton
                                value={DurationUnit.HOURS}
                                label='Hours'
                                style={styles.radioButton}
                            />

                            <RadioButton
                                value={DurationUnit.DAYS}
                                label='Days'
                                style={styles.radioButton}
                            />
                        </RadioButtonGroup>
                        <TextField
                            style={{flexGrow: 100, marginLeft: '2em'}}
                            hintText={userLevelDurationUnit != DurationUnit.DAYS ? 'Hours' : 'Days'}
                            type='number'
                            value={userLevelDuration}
                            onChange={ (e, value) =>
                                this.props.onUserLevelDurationUpdate(true, userLevelDurationUnit, value ? parseInt(value) : null)
                            }
                        />
                    </div>
                }
                {
                  <div>
                      <Divider style={styles.divider} />
                      <Subheader style={styles.subheader}> Time Targeting Scheduler </Subheader>

                      <Toggle
                          label={isPartedGlance ? 'Time targeting enabled' : 'Time targeting disabled'}
                          labelPosition='right'
                          defaultToggled={isPartedGlance}
                          onToggle={(e, checked)=>{this.props.onPartingTimeUpdate(checked, this.state.partingSchedule)}}
                      />
                  </div>
                }
                { isPartedGlance &&
                    <PartingTimeSelection isPartedGlance={isPartedGlance}
                        partingSchedule={partingSchedule}
                        handlePartingDataChange={this.handlePartingDataChange}
                        handleRemoveSlot={this.handleRemoveSlot}
                    />
                }
                </div>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/drafts/components/GlanceRegionPublish.tsx